import React from 'react';
import startProjectImg from "../../assets/images/home/startProjectImg.png";
import {Link} from "react-router-dom";

export const StartYourProject = () => {
  return (
    <div className='startProject'>
        <div className='container'>
            <div className='startGrid'>
                <div className='startLeft'>
                    <div className='startTitle'>Start Your Property Journey Today</div>
                    <div className='startSubTitle'>Whether you're looking for your dream home, a peaceful plot, or a smart investment — SnapBid makes it easy to express interest, inspect properties, and bid confidently without the usual pressure.</div>

                </div>
                <div className='startRight'>
                    <Link to="/properties"><button>Browse Properties</button></Link>

                </div>

            </div>

        </div>

    </div>
  )
}
